// import React, { useEffect, useMemo } from "react";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Polyline,
//   useMap,
//   Tooltip,
// } from "react-leaflet";
// import L from "leaflet";
// import LocationPin from "../../assets/images/dashboard/locationPin.png";

// function RouteView(props) {
//   console.log("DriversData in mapView", props);

//   // Check if props and tripDetails are defined and not empty
//   const tripDetails = props?.tripDetails || {};
//   const cabRequestDetails = tripDetails?.cabRequestDetails || [];

//   console.log("cabRequestDetails", cabRequestDetails);

//   // Safely access pickup and drop locations
//   const { pickup_location = {}, drop_location = {} } =
//     cabRequestDetails[0] || {};

//   // Coordinates for pickup and drop location
//   const pickupCoords = [pickup_location.latitude, pickup_location.longitude];
//   const dropCoords = [drop_location.latitude, drop_location.longitude];

//   // Generate a unique key for the MapContainer to force re-render on location change
//   const mapKey = useMemo(() => JSON.stringify([pickupCoords, dropCoords]), [
//     pickupCoords,
//     dropCoords,
//   ]);

//   const customIcon = L.icon({
//     iconUrl: LocationPin, // Path to the auto icon image
//     iconSize: [30, 30], // Size of the icon
//     iconAnchor: [15, 30], // Anchor point of the icon (middle bottom)
//   });

//   // Handle case where pickup and drop locations are invalid
//   if (!cabRequestDetails.length) {
//     return <div>No trip details available.</div>;
//   }

//   // Custom hook to zoom the map to fit pickup and drop locations
//   function ZoomToBounds() {
//     const map = useMap();
//     useEffect(() => {
//       if (pickupCoords.length && dropCoords.length) {
//         const bounds = L.latLngBounds([pickupCoords, dropCoords]);
//         map.fitBounds(bounds, {
//           padding: [50, 50], // Padding around the bounds
//           maxZoom: 15, // Maximum zoom level to fit bounds
//         });
//       }
//     }, [map, pickupCoords, dropCoords]);

//     return null;
//   }

//   // Handle case where pickup and drop locations are empty or invalid
//   if (!pickupCoords.length || !dropCoords.length) {
//     return <div>No route data available.</div>;
//   }

//   return (
//     <MapContainer
//       key={mapKey} // Unique key to force re-render
//       center={pickupCoords}
//       zoom={13}
//       style={{ height: "300px", width: "100%" }}
//       scrollWheelZoom={false}
//     >
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//       />
//       <ZoomToBounds /> {/* Custom hook to zoom the map */}
//       <Polyline positions={[pickupCoords, dropCoords]} color="blue" />
//       <Marker position={pickupCoords} icon={customIcon}>
//         <Tooltip permanent>{pickup_location?.subtext || "Pickup location"}</Tooltip>
//       </Marker>
//       <Marker position={dropCoords} icon={customIcon}>
//         <Tooltip permanent>{drop_location?.subtext || "Drop location"}</Tooltip>
//       </Marker>
//     </MapContainer>
//   );
// }

// export default RouteView;

import React, { useEffect, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  useMap,
  Tooltip,
} from "react-leaflet";
import L from "leaflet";
import LocationPin from "../../assets/images/dashboard/locationPin.png";

function RouteView(props) {
  console.log("DriversData in mapView", props);

  const tripDetails = props?.tripDetails || {};
  const cabRequestDetails = tripDetails?.cabRequestDetails || [];

  console.log("cabRequestDetails", cabRequestDetails);

  // const { pickup_location = {}, drop_location = {} } =
  //   cabRequestDetails[0] || {};

  // const pickupCoords = [
  //   pickup_location?.latitude || 0,
  //   pickup_location?.longitude || 0,
  // ];
  // const dropCoords = [
  //   drop_location?.latitude || 0,
  //   drop_location?.longitude || 0,
  // ];
  const pickup_location = cabRequestDetails[0]?.pickup_location || {};
  const drop_location = cabRequestDetails[0]?.drop_location || {};

  const pickupCoords = [
    pickup_location?.latitude ?? 0,  // Use nullish coalescing to ensure fallback values
    pickup_location?.longitude ?? 0,
  ];
  const dropCoords = [
    drop_location?.latitude ?? 0,
    drop_location?.longitude ?? 0,
  ];

  const mapKey = useMemo(() => JSON.stringify([pickupCoords, dropCoords]), [
    pickupCoords,
    dropCoords,
  ]);

  const customIcon = L.icon({
    iconUrl: LocationPin,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });

  // Handle case where no valid locations are provided
  if (!cabRequestDetails.length || !pickup_location.latitude || !drop_location.latitude) {
    return <div>No trip details available.</div>;
  }

  // Custom hook to zoom the map bounds
  function ZoomToBounds() {
    const map = useMap();

    useEffect(() => {
      if (pickupCoords[0] && dropCoords[0]) {
        const bounds = L.latLngBounds([pickupCoords, dropCoords]);
        map.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 15,
        });
      }
    }, [map, pickupCoords, dropCoords]);

    return null;
  }

  return (
    <MapContainer
      key={mapKey}
      center={pickupCoords}
      zoom={13}
      style={{ height: "300px", width: "100%" }}
      scrollWheelZoom={false}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <ZoomToBounds />
      <Polyline positions={[pickupCoords, dropCoords]} color="blue" />
      <Marker position={pickupCoords} icon={customIcon}>
        <Tooltip permanent>{pickup_location?.subtext || "Pickup location"}</Tooltip>
      </Marker>
      <Marker position={dropCoords} icon={customIcon}>
        <Tooltip permanent>{drop_location?.subtext || "Drop location"}</Tooltip>
      </Marker>
    </MapContainer>
  );
}

export default RouteView;
